import { getApiGalaxyServer } from 'services';
import { ActivityLogQueryParams, ActivityLogResponse } from '../types/activityLog';

/**
 * Fetch activity logs from the backend API
 *
 * @see galaxy-server PR #862 for backend implementation
 * @endpoint GET /activity-log
 */
export const activityLogApi = ({
  params,
  token,
  config,
}: BaseApiParams<ActivityLogQueryParams>) => {
  return getApiGalaxyServer<ActivityLogResponse>(
    `/activity-log`,
    {
      ...config,
      params: params as any,
    },
    token,
  );
};
